"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "sortable-cards" };
const _hoisted_3 = ["onDragstart"];
const _hoisted_4 = ["onDragover"];
const _hoisted_5 = {
    key: 0,
    class: "reorder-banners-container"
};
const _hoisted_6 = {
    key: 0,
    class: "reorder-banners-left"
};
const _hoisted_7 = {
    key: 1,
    class: "reorder-banners-right"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Card = (0, vue_1.resolveComponent)("Card");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [
        (_ctx.experimentalUI())
            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
                (0, vue_1.createElementVNode)("label", null, [
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.showReorder) = $event))
                    }, null, 512), [
                        [vue_1.vModelCheckbox, _ctx.showReorder]
                    ]),
                    _cache[4] || (_cache[4] = (0, vue_1.createTextVNode)(" Reorder Cards ", -1))
                ])
            ])), [
                [_directive_i18n]
            ])
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getSortedCards(), (card, index) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    ref_for: true,
                    ref: "draggers",
                    class: (0, vue_1.normalizeClass)({ 'dragging': Boolean(_ctx.dragCard) }),
                    key: card.name,
                    draggable: "true",
                    onDragend: _cache[2] || (_cache[2] = ($event) => (_ctx.onDragEnd())),
                    onDragstart: ($event) => (_ctx.onDragStart(card.name))
                }, [
                    (_ctx.dragCard)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: 0,
                            ref_for: true,
                            ref: "droppers",
                            class: "drop-target",
                            onDragover: ($event) => (_ctx.onDragOver(card.name))
                        }, null, 40, _hoisted_4))
                        : (0, vue_1.createCommentVNode)("", true),
                    (0, vue_1.createElementVNode)("div", {
                        ref_for: true,
                        ref: "cardbox",
                        class: "cardbox",
                        onClick: _cache[1] || (_cache[1] =
                            (...args) => (_ctx.clickMethod && _ctx.clickMethod(...args)))
                    }, [
                        (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"]),
                        (_ctx.showReorder)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [
                                (index > 0)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (index < _ctx.cards.length - 1)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7))
                                    : (0, vue_1.createCommentVNode)("", true)
                            ]))
                            : (0, vue_1.createCommentVNode)("", true)
                    ], 512)
                ], 42, _hoisted_3));
            }), 128)),
            (_ctx.dragCard)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    key: 0,
                    ref: "dropend",
                    class: "drop-target",
                    onDragover: _cache[3] || (_cache[3] = ($event) => (_ctx.onDragOver('end')))
                }, null, 544))
                : (0, vue_1.createCommentVNode)("", true)
        ])
    ]));
}
